import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    height: 100%;
    background-color: ${props => props.theme.backgroundColor};
}
`;

export const ToolBoxArea = styled.div`
    position: absolute;
    right: 10px;
    top: 10px;
    float: right;
    height: auto;
    width: auto;
    z-index: 100;
    min-height: auto;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 10px;
}
`;
